
// default axios http request timeout in ms.
export const API_DEFAULT_TIMEOUT = 20000;

export const NEDGLOBE_CUSTOM_REFCODES = {
    'TRANSLATED': false,
    'ENTRIES': {

        'BOOL_OR_SYSTEM': [{
            'code': 'N',
            'description': 'RefcodeNo'
        }, {
            'code': 'Y',
            'description': 'RefcodeYes'
        }, {
            'code': 'S',
            'description': 'RefcodeSystemSettings'
        }],

        'LANGUAGE': [{
            'code': 'NL',
            'description': 'RefcodeNL'
        }, {
            'code': 'EN',
            'description': 'RefcodeEN'
        }],

        'SORT_WEBTHEME': [{
            'code': 'T',
            'description': 'RefcodeSortT'
        }, {
            'code': 'P',
            'description': 'RefcodeSortP'
        }],

        'FIELD_TYPE': [{
            'code': 'A',
            'description': 'RefcodeFieldA'
        }, {
            'code': 'C',
            'description': 'RefcodeFieldC'
        }, {
            'code': 'D',
            'description': 'RefcodeFieldD'
        }, {
            'code': 'E',
            'description': 'RefcodeFieldE'
        }, {
            'code': 'F',
            'description': 'RefcodeFieldF'
        }, {
            'code': 'G',
            'description': 'RefcodeFieldG'
        }, {
            'code': 'N',
            'description': 'RefcodeFieldN'
        }, {
            'code': 'ND',
            'description': 'RefcodeFieldND'
        }, {
            'code': 'S',
            'description': 'RefcodeFieldS'
        }, {
            'code': 'X',
            'description': 'RefcodeFieldX'
        }, {
            'code': '-',
            'description': 'RefcodeFieldDash'
        }],

        'DOMAIN_TYPE': [{
            'code': 'D',
            'description': 'RefcodeDomainD'
        }, {
            'code': 'S',
            'description': 'RefcodeDomainS'
        }, {
            'code': 'A',
            'description': 'RefcodeDomainA'
        }, {
            'code': '-',
            'description': 'RefcodeDomainDash'
        }],

        'VALUE_INPUT': [{
            'code': 'DA',
            'description': 'RefcodeValueDA'
        }, {
            'code': 'DO',
            'description': 'RefcodeValueDO'
        }, {
            'code': 'TE',
            'description': 'RefcodeValueTE'
        }],

        'INFO_LINK': [{
            'code': 'X',
            'description': 'RefcodeInfoLinkTypeX'
        }, {
            'code': 'M',
            'description': 'RefcodeInfoLinkTypeM'
        }],

        'OPERATOR': [{
            'code': '=',
            'description': '='
        }, {
            'code': '<',
            'description': '<'
        }, {
            'code': '<=',
            'description': '<='
        }, {
            'code': '>',
            'description': '>'
        }, {
            'code': '>=',
            'description': '>='
        }, {
            'code': '<>',
            'description': '<>'
        }, {
            'code': 'C',
            'description': 'RefcodeOperatorC'
        }, {
            'code': 'S',
            'description': 'RefcodeOperatorS'
        }, {
            'code': 'E',
            'description': 'RefcodeOperatorE'
        }],

        'AUTHENTICATION_TYPE': [{
            'code': 'B',
            'description': 'RefcodeAuthenticationB'
        }, {
            'code': 'N',
            'description': 'RefcodeAuthenticationN'
        }],

        'PRIORITY': [{
            'code': 'H',
            'description': 'RefcodePriorityH'
        }, {
            'code': 'N',
            'description': 'RefcodePriorityN'
        }, {
            'code': 'L',
            'description': 'RefcodePriorityL'
        }],

        'WHERECLAUSE_TYPE': [{
            'code': 'F',
            'description': 'RefcodeWhereClauseF'
        }, {
            'code': 'R',
            'description': 'RefcodeWhereClauseR'
        }],

        'WEBJOB_STATUS': [{
            'code': 'G0',
            'description': 'RefcodeWebjobStatusG0'
        }, {
            'code': 'G1',
            'description': 'RefcodeWebjobStatusG1'
        }, {
            'code': 'D1',
            'description': 'RefcodeWebjobStatusD1'
        }, {
            'code': 'D2',
            'description': 'RefcodeWebjobStatusD2'
        }, {
            'code': 'D3',
            'description': 'RefcodeWebjobStatusD3'
        }, {
            'code': 'D4',
            'description': 'RefcodeWebjobStatusD4'
        }, {
            'code': 'C0',
            'description': 'RefcodeWebjobStatusC0'
        }, {
            'code': 'C1',
            'description': 'RefcodeWebjobStatusC1'
        }, {
            'code': 'C2',
            'description': 'RefcodeWebjobStatusC2'
        }, {
            'code': 'C3',
            'description': 'RefcodeWebjobStatusC3'
        }, {
            'code': 'C4',
            'description': 'RefcodeWebjobStatusC4'
        }, {
            'code': 'C5',
            'description': 'RefcodeWebjobStatusC5'
        }, {
            'code': 'C6',
            'description': 'RefcodeWebjobStatusC6'
        }, {
            'code': 'RC1',
            'description': 'RefcodeWebjobStatusRC1'
        }, {
            'code': 'RC2',
            'description': 'RefcodeWebjobStatusRC2'
        }, {
            'code': 'RC3',
            'description': 'RefcodeWebjobStatusRC3'
        }, {
            'code': 'R1',
            'description': 'RefcodeWebjobStatusR1'
        }, {
            'code': 'R2',
            'description': 'RefcodeWebjobStatusR2'
        }, {
            'code': 'R3',
            'description': 'RefcodeWebjobStatusR3'
        }, {
            'code': 'FM1',
            'description': 'RefcodeWebjobStatusFM1'
        }, {
            'code': 'FM2',
            'description': 'RefcodeWebjobStatusFM2'
        }, {
            'code': 'FM3',
            'description': 'RefcodeWebjobStatusFM3'
        }]
    }
};

// API types
export const API_TYPE = {
    'NONE': 'none',
    'API': 'api',
    'WEBAPI': 'webApi'
};

// API types
export const PROFILE_TYPE = {
    'BASELAYER': 1,
    'THEME_FEEDBACK': 2,
    'API': 3
};

// Add form mode
export const MODE_ADD = 0;
// Edit form mode
export const MODE_EDIT = 1;

// NedGlobe Services OWS name
export const NEDGLOBE_SERVICES = 'NedGlobe Services';

export const APPLICATION_JSON = 'application/json';

export const EXTERNAL_API_NAMES = {
    'BRK': 'BRK',
    'BRK-TEST': 'BRK-test',
    'STUFF': 'StUF-BG-API'
};

export const EXTERNAL_API_TYPE = {
    'BRK': 0,
    'STUFF': 1,
    'KVK': 2,
    'ENERGYLABEL': 3,
    'BRP': 4,
    'WOZ': 5
};

export const API_URL_TYPE = {
    'BASE': 'Base',
    'ORGANIZATION': 'Organization'
};

export const AUTHENTICATION_TYPE = {
    // Ref Code Key
    'KEY': 'AUTHENTICATION_TYPE',
    // Ref Code  Values
    'HTTP_BASIC_AUTHENTICATION': 'B',
    'NONE': 'N'
};

export const DOMAIN_TYPE = {
    // Ref Code Key
    'KEY': 'DOMAIN_TYPE',
    // Ref Code  Values
    'DROPDOWNLIST': 'D',
    'SUGGESTIONLIST': 'S',
    'ALL_VALUES': 'A',
    'SELECT': '-'
};

export const FIELD_TYPE = {
    // Ref Code Key
    'KEY': 'FIELD_TYPE',
    // Ref Code  Values
    'ALPHANUMERIC': 'A',
    'CATEGORY': 'C',
    'DATE': 'D',
    'EMAIL': 'E',
    'FOTO': 'F',
    'GENERIC': 'G',
    'NUMERIC': 'N',
    'NUMERICWITHDECIMALS': 'ND',
    'STATE': 'S',
    'VIDEO': 'V',
    'EXPRESSION': 'X',
    'SELECT': '-'
};

export const OPERATOR_TYPE = {
    // Ref Code Key
    'KEY': 'OPERATOR',
    // Ref Code  Values
    '<=': '<=',
    '<>': '<>',
    '=': '=',
    '>=': '>=',
    'C': 'C',
    '>': '>',
    '<': '<',
    'S': 'S',
    'E': 'E'
};

export const PRIORITY = {
    // Ref Code Key
    'KEY': 'PRIORITY',
    // Ref Code  Values
    'HIGH': 'H',
    'NORMAL': 'N',
    'LOW': 'L'
};

export const VALUE_INPUT_TYPE = {
    // Ref Code Key
    'KEY': 'VALUE_INPUT',
    // Ref Code  Values
    'DATEFIELD': 'DA',
    'DOMAIN': 'DO',
    'TEXTFIELD': 'TE'
};

export const INFO_LINK_TYPE = {
    // Ref Code Key
    'KEY': 'INFO_LINK',
    // Ref Code  Values
    'EXTERNAL': 'X',
    'METADATA': 'M'
};

export const WEBJOB_STATUS = {
    // Ref Code Key
    'KEY': 'WEBJOB_STATUS',
    // Ref Code  Values
    'NO_REQUEST_SENT': 'G0',
    'REQUEST_SENT_PLEASE_WAIT': 'G1',
    'DOMAIN_GENERATION_IN_PROGRESS': 'D1',
    'DOMAIN_GENERATION_FINISHED': 'D2',
    'DOMAIN_GENERATION_ERROR': 'D3',
    'VERIFICATION_HAS_STARTED': 'C0',
    'VERIFICATION_IN_PROGRESS': 'C1',
    'VERIFICATION_FINISHED': 'C2',
    'VERIFICATION_ERROR': 'C3',
    'VERIFICATION_STOPPED': 'C4',
    'VERIFICATION_IN_PROGRESS_SOURCE': 'C5',
    'VERIFICATION_IN_PROGRESS_LAYER': 'C6',
    'SEARCH_CACHE_IN_PROGRESS': 'R1',
    'SEARCH_CACHE_FINISHED': 'R2',
    'SEARCH_CACHE_ERROR': 'R3',
    'SEARCH_CACHE_CLEAR_IN_PROGRESS': 'RC1',
    'SEARCH_CACHE_CLEAR_FINISHED': 'RC2',
    'SEARCH_CACHE_CLEAR_ERROR': 'RC3',
    'FEEDBACK_IN_PROGRESS': 'FM1',
    'FEEDBACK_MAINTENANCE_FINISHED': 'FM2',
    'FEEDBACK_MAINTENANCE_ERROR': 'FM3'
};

export const WHERECLAUSE_TYPE = {
    // Ref Code Key
    'KEY': 'WHERECLAUSE_TYPE',
    // Ref Code  Values
    'FILTER': 'F',
    'REMOVE': 'R'
};

export const TOGGLE_PAGING = {
    'next': 'next',
    'previous': 'previous',
    'first': 'first',
    'last': 'last'
};

// Max length constraints
export const MAX_LENGTH_CONSTRAINTS = {
    'NUMERIC': 9,
    'NUMERICWITHDECIMALS': 20,
    'ALPHANUMERIC': 4000,
    'NUMBEROFROWS': 20
};

export const MESSAGE_TYPE = {
    GetCurrentScale: 'web-dashboard-get-current-scale',
    UpdateMaplocation: 'web-dashboard-update-maplocation',
    SetMapLocationDefault: 'dashboard-web-set-maplocation-default',
    SetMapLocationOrganizationBbox: 'dashboard-web-set-maplocation-organizationbbox',
    SetMapLocationScale: 'dashboard-web-set-maplocation-scale',
};

export const CONTENT_TYPE_ID = {
    'FEEDBACK': 1,
    'MEASUREMENT': 2,
    'SKETCH': 3,
    'WFS_T': 4
};

export const ORGANIZATION_IMAGES = {
    LOGO: 1,
    FAVICON: 2
};

export const AVAILABLE_LOGO_TYPE = [
    { text: 'Logo', value: ORGANIZATION_IMAGES.LOGO },
    { text: 'Favicon', value: ORGANIZATION_IMAGES.FAVICON },
    { text: 'Button', value: 3 },
    { text: 'Noordpijl', value: 4 }
];

export const URL_CONNECTION_TYPE = {
    'StreetView': 1,
    'Others': 2
};

export const INPUT_TYPE = {
    'Text': 'text',
    'Password': 'password'
};

export const API_ERROR_CODES = { unauthorized: 401 };

export const RELATIONSHIP_TYPES = {
    'ThemeLayer2ThemeLayer': 0,
    'ThemeLayer2Table': 1,
    'Table2ThemeLayer': 2,
    'Table2Table': 3
};

export const RELATION_TYPES = {
    'Normal': 0,
    'Spatial': 1
};

export const RELATION_FIELD_DATA_TYPES = {
    'string': 'string',
    'number': 'number',
    'date': 'date',
};

export const EXTERNAL_OPEN_APIS = {
    bagservice: { uri: 'https://service.pdok.nl/lv/bag/wfs/v2_0' }
};

export const ICON_UNITS = {
    pixels: 'px',
    meters: 'm',
};

export const FUNCTION_RESULTS = {
    checkCertificateExpiration: 'CheckCertificateExpiration',
    deletedOrganization: 'DeleteOrganizationFunction',
    applyProduct: 'applyProduct'
};

export const PROFILE_NAMES = {
    'NedBRK': 'NedBRK'
};

export const TYPE_3D_LAYER = {
    TILESET_3D: '3DTileset'
};
